<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <vs-input label="Name" v-model="name" class="mt-5 w-full" name="item-name" v-validate="'required'" />
    <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

    <label class="vs-input--label">Description</label>

    <div class="mt-5">
      <vs-textarea v-model="description" />
    </div>
    <span class="text-danger text-sm" v-show="errors.has('item-code')">{{ errors.first('item-code') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      name: this.name,
      description: this.description
    }
  },
  computed: {
  }
}
</script>
